/**
 * Provides service functions for managing user language preferences,
 * including retrieving the current language setting and saving language
 * selections through backend APIs.
 */
import { api } from "@/api";

/* ==========================
   Get Language
========================== */
export async function getUserLanguage(upn: string): Promise<any> {
  const res = await api.language(upn);
  return res;
}

/* ==========================
   Save Language
========================== */
export async function saveUserLanguage(payload: any): Promise<any> {
  const res = await api.saveLanguage(payload);
  return res;
}
